import { Button } from "@clockwise/design-system";
import pluralize from "pluralize";
import React from "react";

type Props = {
  disabled?: boolean;
  conflictCount?: number;
  onSave: () => void;
  onSaveAndFix: () => void;
};
export const Footer = ({ disabled = false, conflictCount = 0, onSave, onSaveAndFix }: Props) => {
  return (
    <div className="cw-flex cw-justify-end cw-p-3 cw-gap-2">
      {conflictCount > 0 && (
        <Button variant="outlined" size="xsmall" onClick={onSaveAndFix} disabled={disabled}>
          Save & fix {pluralize("conflict", conflictCount, true)}
        </Button>
      )}
      <Button sentiment="positive" size="xsmall" onClick={onSave} disabled={disabled}>
        Save
      </Button>
    </div>
  );
};
